import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { ReportFieldEnum } from 'Common/FieldEnum';
import moment from 'moment';
import {
  SelectField,
  DatePickerField,
  CheckboxField,
  Radio,
} from 'Common/SemanticWrapper';
import { SiteComponent } from 'Common/SiteComponent';
import { DropdownObjectCreator } from 'Common/ObjectHelper';
import { TRANSACTION_HISTORY_BY_DATE_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components';

class TransactionHistoryByDateForm extends Component {
  state = {
    CheckAllType: true,
    selectedSiteId: '',
    isLunch: false,
    isBreakFast: false,
    isSupper: false,
    isOther: false,
    isManualAdjustment: false,
    isZeroBalanceAdjustment: false,
    isAllTypes: false,
    siteChange: false,
    disableOption: false,
  };

  additionalFilterChange = data => {
    if (data === '0') {
      this.setState(
        {
          CheckAllType: true,
          isAllTypes: false,
          isBreakFast: false,
          isLunch: false,
          isSupper: false,
          isOther: false,
          isManualAdjustment: false,
          isZeroBalanceAdjustment: false,
          disableOption: false,
        },
        () => {
          this.props.change(`${ReportFieldEnum.Other}`, this.state.isOther);
          this.props.change(`${ReportFieldEnum.Supper}`, this.state.isSupper);
          this.props.change(`${ReportFieldEnum.Lunch}`, this.state.isLunch);
          this.props.change(
            `${ReportFieldEnum.Breakfast}`,
            this.state.isBreakFast
          );
          this.props.change(
            `${ReportFieldEnum.ZeroBalanceAdjustment}`,
            this.state.isZeroBalanceAdjustment
          );
          this.props.change(
            `${ReportFieldEnum.ManualAdjustments}`,
            this.state.isManualAdjustment
          );

          this.props.change(`${ReportFieldEnum.All}`, this.state.isAllTypes);
        }
      );
    } else {
      this.setState(
        {
          isBreakFast: true,
          isLunch: true,
          isSupper: true,
          isOther: true,
          disableOption: true,
          isManualAdjustment: false,
          isZeroBalanceAdjustment: false,
          isAllTypes: false,
        },
        () => {
          this.props.change(`${ReportFieldEnum.Other}`, true);

          this.props.change(`${ReportFieldEnum.Supper}`, true);
          this.props.change(`${ReportFieldEnum.Lunch}`, true);
          this.props.change(`${ReportFieldEnum.Breakfast}`, true);
          this.props.change(
            `${ReportFieldEnum.ZeroBalanceAdjustment}`,
            this.state.isZeroBalanceAdjustment
          );
          this.props.change(
            `${ReportFieldEnum.ManualAdjustments}`,
            this.state.isManualAdjustment
          );

          this.props.change(`${ReportFieldEnum.All}`, this.state.isAllTypes);
        }
      );
    }
  };

  changeSites = data => {
    this.setState({ siteChange: true });
    this.props.change(`${ReportFieldEnum.User}`, 'ALL');
  };

  updateAdditionFilters = (e, data) => {
    switch (e) {
      case ReportFieldEnum.Lunch:
        this.props.change(`${ReportFieldEnum.Lunch}`, !this.state.isLunch);
        this.setState({ isLunch: !this.state.isLunch });
        if (
          this.state.isManualAdjustment &&
          this.state.isZeroBalanceAdjustment &&
          this.state.isOther &&
          this.state.isBreakFast &&
          this.state.isBreakFast
        ) {
          this.props.change(`${ReportFieldEnum.All}`, !this.state.isLunch);
          this.setState({ isAllTypes: !this.state.isLunch });
        }
        break;
      case ReportFieldEnum.Breakfast:
        this.props.change(
          `${ReportFieldEnum.Breakfast}`,
          !this.state.isBreakFast
        );
        this.setState({
          isBreakFast: !this.state.isBreakFast,
        });
        if (
          this.state.isManualAdjustment &&
          this.state.isZeroBalanceAdjustment &&
          this.state.isOther &&
          this.state.isSupper &&
          this.state.isLunch
        ) {
          this.props.change(`${ReportFieldEnum.All}`, !this.state.isBreakFast);
          this.setState({ isAllTypes: !this.state.isBreakFast });
        }
        break;
      case ReportFieldEnum.Supper:
        this.props.change(`${ReportFieldEnum.Supper}`, !this.state.isSupper);
        this.setState({ isSupper: !this.state.isSupper });
        if (
          this.state.isManualAdjustment &&
          this.state.isZeroBalanceAdjustment &&
          this.state.isOther &&
          this.state.isBreakFast &&
          this.state.isLunch
        ) {
          this.props.change(`${ReportFieldEnum.All}`, !this.state.isSupper);
          this.setState({ isAllTypes: !this.state.isSupper });
        }
        break;
      case ReportFieldEnum.Other:
        this.setState({ isOther: !this.state.isOther });
        this.props.change(`${ReportFieldEnum.Other}`, !this.state.isOther);
        if (
          this.state.isManualAdjustment &&
          this.state.isZeroBalanceAdjustment &&
          this.state.isSupper &&
          this.state.isBreakFast &&
          this.state.isLunch
        ) {
          this.props.change(`${ReportFieldEnum.All}`, !this.state.isOther);
          this.setState({ isAllTypes: !this.state.isOther });
        }
        break;
      case ReportFieldEnum.ManualAdjustments:
        this.props.change(
          `${ReportFieldEnum.ManualAdjustments}`,
          !this.state.isManualAdjustment
        );
        this.setState({
          isManualAdjustment: !this.state.isManualAdjustment,
        });
        if (
          this.state.isOther &&
          this.state.isZeroBalanceAdjustment &&
          this.state.isSupper &&
          this.state.isBreakFast &&
          this.state.isLunch
        ) {
          this.props.change(
            `${ReportFieldEnum.All}`,
            !this.state.isManualAdjustment
          );
          this.setState({ isAllTypes: !this.state.isManualAdjustment });
        }
        break;
      case ReportFieldEnum.ZeroBalanceAdjustment:
        this.props.change(
          `${ReportFieldEnum.ZeroBalanceAdjustment}`,
          !this.state.isZeroBalanceAdjustment
        );
        this.setState({
          isZeroBalanceAdjustment: !this.state.isZeroBalanceAdjustment,
        });
        if (
          this.state.isOther &&
          this.state.isManualAdjustment &&
          this.state.isSupper &&
          this.state.isBreakFast &&
          this.state.isLunch
        ) {
          this.props.change(
            `${ReportFieldEnum.All}`,
            !this.state.isZeroBalanceAdjustment
          );
          this.setState({ isAllTypes: !this.state.isZeroBalanceAdjustment });
        }

        break;
      case ReportFieldEnum.All:
        this.setState({
          isAllTypes: !this.state.isAllTypes,
          isBreakFast: !this.state.isAllTypes,
          isLunch: !this.state.isAllTypes,
          isSupper: !this.state.isAllTypes,
          isOther: !this.state.isAllTypes,
          isManualAdjustment: !this.state.isAllTypes,
          isZeroBalanceAdjustment: !this.state.isAllTypes,
        });
        this.props.change(
          `${ReportFieldEnum.ZeroBalanceAdjustment}`,
          !this.state.isAllTypes
        );
        this.props.change(
          `${ReportFieldEnum.ManualAdjustments}`,
          !this.state.isAllTypes
        );
        this.props.change(`${ReportFieldEnum.Other}`, !this.state.isAllTypes);
        this.props.change(`${ReportFieldEnum.Supper}`, !this.state.isAllTypes);
        this.props.change(`${ReportFieldEnum.Lunch}`, !this.state.isAllTypes);
        this.props.change(
          `${ReportFieldEnum.Breakfast}`,
          !this.state.isAllTypes
        );
        this.props.change(`${ReportFieldEnum.All}`, !this.state.isAllTypes);
        break;
      default:
    }
  };

  updateAllFilter = checked => {};

  render() {
    const { usersData } = this.props;
    let users = [];
    users = usersData
      ? DropdownObjectCreator(usersData, 'UserId', 'UserName')
      : [];
    if (users.length > 1) {
      users.unshift({
        value: 'ALL',
        text: 'ALL',
        key: 'valueALL',
      });
    }

    return (
      <Form>
        <TitledCard title={'Report Parameters'}>
          <Grid style={{ paddingBottom: '10px' }}>
            <Grid.Row columns={2}>
              <Grid.Column>
                <SiteComponent
                  name={ReportFieldEnum.Site}
                  dropDownChange={this.changeSites}
                  {...this.props}
                  isForm={true}
                  isPrimary={true}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.User}
                  component={SelectField}
                  type="text"
                  label="USER"
                  options={users}
                  loading={this.props.userLoad}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.FromDate}
                  component={DatePickerField}
                  type="text"
                  label="From"
                  openToDate={moment().add(-1, 'days')}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.ToDate}
                  component={DatePickerField}
                  type="text"
                  label="To"
                  openToDate={moment()}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ marginLeft: '16px', paddingBottom: '0px' }}>
              <div className="ui form field">
                <label>TYPE</label>
              </div>
            </Grid.Row>
            <Grid.Row columns={6} style={{ paddingTop: '0px' }}>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Breakfast}
                  label="Breakfast"
                  component={CheckboxField}
                  disabled={this.state.disableOption}
                  checked={!this.state.CheckAllType || this.state.isBreakFast}
                  onChange={(e, data) =>
                    this.updateAdditionFilters(ReportFieldEnum.Breakfast, data)
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Lunch}
                  label="Lunch"
                  component={CheckboxField}
                  disabled={this.state.disableOption}
                  checked={!this.state.CheckAllType || this.state.isLunch}
                  onChange={(e, data) =>
                    this.updateAdditionFilters(ReportFieldEnum.Lunch, data)
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Supper}
                  label="Supper"
                  component={CheckboxField}
                  checked={!this.state.CheckAllType || this.state.isSupper}
                  disabled={this.state.disableOption}
                  onChange={(e, data) =>
                    this.updateAdditionFilters(ReportFieldEnum.Supper, data)
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Other}
                  label="Other"
                  component={CheckboxField}
                  checked={!this.state.CheckAllType || this.state.isOther}
                  disabled={this.state.disableOption}
                  onChange={(e, data) =>
                    this.updateAdditionFilters(ReportFieldEnum.Other, data)
                  }
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={6} style={{ paddingTop: '0px' }}>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.ManualAdjustments}
                  label="Manual Adjustments"
                  component={CheckboxField}
                  checked={
                    !this.state.CheckAllType || this.state.isManualAdjustment
                  }
                  onChange={(e, data) =>
                    this.updateAdditionFilters(
                      ReportFieldEnum.ManualAdjustments,
                      data
                    )
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.ZeroBalanceAdjustment}
                  label="Zero Balance Adjustments"
                  component={CheckboxField}
                  checked={
                    !this.state.CheckAllType ||
                    this.state.isZeroBalanceAdjustment
                  }
                  onChange={(e, data) =>
                    this.updateAdditionFilters(
                      ReportFieldEnum.ZeroBalanceAdjustment,
                      data
                    )
                  }
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingTop: '0px', paddingBottom: '0px' }}>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.All}
                  label="All"
                  component={CheckboxField}
                  checked={!this.state.CheckAllType || this.state.isAllTypes}
                  disabled={this.state.disableOption}
                  onChange={(e, data) =>
                    this.updateAdditionFilters(ReportFieldEnum.All, data)
                  }
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingBottom: '0px', paddingTop: '0px' }}>
              <Grid.Column>
                <div className="field">
                  <label>ADDITIONAL FILTERS</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row
              columns={6}
              style={{ paddingTop: '0px', paddingBottom: '0px' }}
            >
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.AdditionalFilters}
                  component={Radio}
                  label={'Voids Only'}
                  myValue="1"
                  onChange={(e, data) =>
                    this.additionalFilterChange(data.value)
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.AdditionalFilters}
                  component={Radio}
                  label={'Refunds Only'}
                  myValue="2"
                  onChange={(e, data) => this.additionalFilterChange(data)}
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  name={ReportFieldEnum.AdditionalFilters}
                  component={Radio}
                  label={'Visiting Students Only'}
                  myValue="3"
                  onChange={(e, data) => this.additionalFilterChange(data)}
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  name={ReportFieldEnum.AdditionalFilters}
                  component={Radio}
                  label={'None'}
                  myValue="0"
                  onChange={(e, data) => this.additionalFilterChange(data)}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingBottom: '0px', paddingTop: '0px' }}>
              <Grid.Column>
                <div className="field">
                  <label>SORT BY</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={6} style={{ paddingTop: '0px' }}>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.SortBy}
                  component={Radio}
                  label={'Student ID'}
                  myValue="1"
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.SortBy}
                  component={Radio}
                  label={'Time'}
                  myValue="2"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values[ReportFieldEnum.Site]) {
    errors[ReportFieldEnum.Site] = 'Site selection is required';
  }
  if (!values[ReportFieldEnum.User]) {
    errors[ReportFieldEnum.User] = 'User selection is required';
  }
  return errors;
};

export default reduxForm({
  validate,
  form: TRANSACTION_HISTORY_BY_DATE_FORM_NAME,
})(TransactionHistoryByDateForm);



// WEBPACK FOOTER //
// ./src/pages/transactionhistory/components/TransactionHistoryByDateForm.js